// extracted by mini-css-extract-plugin
export default {"toggleRow":"wX1EWGZTozelZdcuQ7Un","toggleSlot":"VTRelcE1Omzec5RTdRAU","toggleText":"R4nxVILeLRNu8Eb8yR_x"};